import { isStringNullOrWhiteSpace } from 'owa-localize';
import { getDefaultDataProviderInfo } from '../../utils/DataProviderInfo/getDataProviderInfo';
import isMenuActionSupported from '../../utils/isMenuActionSupported';
import { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { logUsage } from 'owa-analytics';
import { AttachmentFullViewState, AttachmentMenuAction } from 'owa-attachment-full-data';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { isFeatureEnabled } from 'owa-feature-flags';
import { openInNewTab } from 'open-in-new-tab';

const ONEDRIVE_SVG = require('../../resources/OneDrive_16x.svg');

export default function viewInProviderContextMenuItemBuilder(
    attachment: AttachmentFullViewState,
    providerType: string,
    targetWindow: Window,
    sxsId: string,
    isConsumer: boolean,
    attachmentOriginalUrl: string
): IContextualMenuItem | null {
    const attachmentModel = getAttachment(attachment.attachmentId);

    if (
        !isMenuActionSupported(AttachmentMenuAction.ViewInProvider, attachment) ||
        !attachment.strategy.isViewingInProviderSupported ||
        !attachmentModel
    ) {
        return null;
    }

    const dataProviderInfo = getDefaultDataProviderInfo(isConsumer);
    const pathName = dataProviderInfo.GetUrlForViewInProviderAction(attachmentOriginalUrl);

    // If we do not have a path to open then we shouldn't show the menu.
    if (isStringNullOrWhiteSpace(pathName)) {
        return null;
    }

    return {
        name: dataProviderInfo.viewInProviderOptionText,
        key: 'ViewInProvider',
        iconProps:
            isFeatureEnabled('wvn-chicletEditOptions') ||
            isFeatureEnabled('wvn-chicletEditOptionsNoDownload')
                ? {
                      imageProps: {
                          src: ONEDRIVE_SVG,
                          width: 16,
                          height: 16,
                          shouldFadeIn: false,
                      },
                  }
                : undefined,
        onClick: () => {
            logUsage('AttachmentContextMenuItemViewInProvider', [providerType]);
            openInNewTab(pathName);
        },
    };
}
